export const keywords = [
	"real estate agent",
	"broker",
	"zero brokerage",
	"no brokerage",
	"settling in",
	"settlin in",
	"settler",
	"best broker in bangalore",
	"best broker in bengaluru",
	"broker in bangalore",
	"broker in bengaluru",
	"real estate agent in bangalore",
	"real estate agent in bengaluru",
	"property service in bangalore",
	"property service in bengaluru",
	"property sale in bangalore",
	"property sale in bengaluru",
];
